<template>
  <fragment>
    <AppBody title="Marketing" subtitle="Configurações">
      <div class="search-forms">
        <div class="marketing-header-dados-cadastrais1">
          <h1 class="marketing-text5">Banner de Publicidade Imply</h1>
          <v-divider></v-divider>
        </div>
        <v-row>
          <v-col cols="12" sm="6">
            <label class="input-labels">Idioma do banner</label>
            <v-select
              v-model="$marketing_configs.cadastro.imagem"
              height="48"
              placeholder="Selecione o tipo de imagem"
              item-text="key"
              item-value="value"
              type="text"
              class="input-file-tema"
              hide-details="auto"
              :items="filteredData"
              :error-messages="$marketing_configs.cadastro.error.imagem"
              @input="$marketing_configs.cadastro.error.imagem = []"
              solo
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="input-labels">Banner</label>
            <v-file-input
              show-size
              accept="image/png, image/jpeg, image/bmp"
              solo
              height="48"
              placeholder="Importar banner"
              hint="A dimensão sugerida para esta imagem é 800x126 pixels e o tamanho máximo é de 200Kb."
              persistent-hint
              clearable
              class="input-file-tema"
              v-model="$marketing_configs.cadastro.banner.object"
              append-icon="mdi-image-outline"
              prepend-icon=""
              clear-icon="mdi-close-circle-outline"
              :append-outer-icon="
                $marketing_configs.cadastro.banner.imagem
                  ? 'mdi-eye-outline'
                  : ''
              "
              @click:append-outer="
                previewImage($marketing_configs.cadastro.banner.imagem)
              "
              @click:clear="clearImage()"
              @change="getImagem($marketing_configs.cadastro.banner.object)"
            >
            </v-file-input>
          </v-col>
        </v-row>
        <v-row class="justify-center justify-sm-end">
          <v-col cols="12" sm="5">
            <v-btn
              :color="$config.dados.corinputs"
              :loading="$marketing_configs.cadastro.loading_imagem"
              class="button btn-size btn-border"
              @click="uploadImage()"
            >
              Fazer upload
              <v-icon class="produtos-gerenciar-icon ml-2"
                >mdi-upload-outline</v-icon
              >
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div
        class="imagens-table"
        v-if="
          $marketing_configs.cadastro.imagens_array &&
          $marketing_configs.cadastro.imagens_array &&
          $marketing_configs.cadastro.imagens_array.length == 0
        "
      >
        <span>Não há registro de imagens.</span>
      </div>
      <v-simple-table fixed-header class="imagens-table" v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <th
                v-for="(header, index) in headersImgs"
                :key="index"
                class="text-center table-header"
              >
                {{ header.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(prodImg, index) in $marketing_configs.cadastro
                .imagens_array"
              :key="index"
            >
              <td class="text-center">{{ Object.keys(prodImg)[0] }}</td>
              <td class="text-center">{{ Object.values(prodImg)[0] }}</td>
              <td class="table-actions">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      small
                      icon
                      @click="previewImage(Object.values(prodImg)[0])"
                    >
                      <v-icon class="produtos-gerenciar-icon"
                        >mdi-eye-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Acessar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      small
                      icon
                      @click="
                        remover(
                          index,
                          Object.keys(prodImg)[0],
                          'Deseja realmente excluir esta imagem?'
                        )
                      "
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <RegistrationActions
        :loader="$marketing_configs.cadastro.loading"
        :actions="actions"
      />
    </AppBody>
    <ModalVisualizarImagem :image="imagemModal" />
    <ModalConfirmacao :textModal="text" @callback="funcaoRemover" />
  </fragment>
</template>

<script>
import { ENDPOINTS } from "@/services/Endpoints.js";
export default {
  name: "Marketing",
  metaInfo: {
    title: "Marketing | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Marketing | ElevenTickets",
      },
    ],
  },
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    ModalVisualizarImagem: () =>
      import("@/components/global/modal-visualizar-imagem.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.$marketing_configs.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => {
            this.$axios.rota("/home");
            location.reload();
          },
        },
      ],

      ENDPOINTS: ENDPOINTS,
      imagemModal: "",
      headersImgs: [
        {
          title: "Imagem",
        },
        {
          title: "Url",
        },
        {
          title: "Ações",
        },
      ],
      tipo_imagem: [
        {
          key: "Banner Português",
          value: "banner_pt",
          show: true,
        },
        {
          key: "Banner Inglês",
          value: "banner_en",
          show: true,
        },
        {
          key: "Banner Espanhol",
          value: "banner_es",
          show: true,
        },
      ],
      text: "",
      index: "",
      imageValue: "",
    };
  },
  methods: {
    getImagem(file) {
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$marketing_configs.cadastro.banner.imagem = reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
    uploadImage() {
      let idiomaImg = "pt";
      let dados = {};
      if (this.$marketing_configs.cadastro.imagem == "") {
        this.$config.alert(
          "Selecione o tipo de imagem!",
          this.$config.dados.errorColor
        );
        this.$marketing_configs.cadastro.error.imagem =
          "Selecione o tipo de imagem!";
        return;
      }

      switch (this.$marketing_configs.cadastro.imagem) {
        case "banner_pt":
          idiomaImg = "pt";
          break;
        case "banner_en":
          idiomaImg = "en";
          break;
        case "banner_es":
          idiomaImg = "es";
          break;
        default:
          idiomaImg = "pt";
          break;
      }

      dados = {
        img_base64: this.$marketing_configs.cadastro.banner.imagem,
        idmarketing: this.$marketing_configs.cadastro.id_marketing,
        idioma: idiomaImg,
      };

      this.$marketing_configs.cadastro.loading_imagem = true;
      this.$axios
        .post(this.ENDPOINTS.UPLOAD_IMAGEM_MARKETING, dados)
        .then(response => {
          if (response) {
            let object = {};

            object[this.$marketing_configs.cadastro.imagem] = response.url;
            this.$marketing_configs.cadastro.imagens_array.push(object);
            this.$marketing_configs.cadastro.loading_imagem = false;

            this.$marketing_configs.cadastro.imagem = "";
            this.$marketing_configs.cadastro.banner.imagem = null;
            delete this.$marketing_configs.cadastro.banner.object;
          }
        });
    },
    clearImage() {
      this.$marketing_configs.cadastro.banner.imagem = null;
      delete this.$marketing_configs.cadastro.banner.object;
    },
    removeImage(index, i) {
      this.$marketing_configs.cadastro.imagens_array.splice(index, 1);
      let tipo = this.tipo_imagem.find(item => item.value === i);
      if (tipo) {
        tipo.show = true;
      }
    },
    previewImage(imagem) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.imagemModal = imagem;
    },
    /**
     * @description Método para abrir o modal de confirmação de remoção da imagem
     * @param {msg} String - Mensagem de confirmação
     */
    remover(index, i, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.imageValue = i;
      this.index = index;
    },
    /**
     * @description Método de confirmação de remoção da imagem
     */
    funcaoRemover() {
      this.removeImage(this.index, this.imageValue);
    },
  },
  computed: {
    filteredData() {
      return this.tipo_imagem.filter(item => item.show === true);
    },
  },
  watch: {
    "$marketing_configs.cadastro.imagens_array"(e) {
      if (this.$marketing_configs.cadastro.imagens_array) {
        e.forEach(obj => {
          const variacaoesFilter = this.tipo_imagem.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacaoesFilter) {
            this.tipo_imagem.map((item, index) => {
              if (variacaoesFilter.value == item.value) {
                this.tipo_imagem[index].show = false;
              }
            });
          }
        });
      }
    },
  },
  mounted() {
    this.tipo_imagem.forEach((obj, index) => {
      const variacaoesFilter =
        this.$marketing_configs.cadastro.imagens_array.find(
          o => Object.keys(o)[0] === obj.value
        );
      if (variacaoesFilter) {
        this.tipo_imagem[index].show = false;
      }
    });

    this.$marketing_configs.getMktConfigs();
  },
};
</script>

<style scoped>
.imagens-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
  margin-top: 2.5rem;
  margin-bottom: 1.25rem;
}

.marketing-header-dados-cadastrais1 {
  width: 100%;
  display: block;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
}

.marketing-text5 {
  font-size: 1em;
  /* padding-top: 20px;
        padding-bottom: 20px; */
}

.input-file-tema {
  border-radius: 10px;
  width: 100%;
}

.marketing-actions {
  flex: 0 0 auto;
  width: 100%;
  height: 20%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  /* margin-top: 1.25rem; */
  margin-bottom: 1.25rem;
}

.marketing-actions-text {
  align-self: center;
}

.marketing-actions-text1 {
  align-self: center;
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white) !important;
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button3 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-icon {
  fill: var(--dl-color-gray-white) !important;
  width: 1.5rem;
  height: 1.5rem;
}

@media (max-width: 1366px) {
  .marketing-banner {
    width: auto;
    height: auto;
    max-height: 280px;
    max-width: 975px;
  }
}
</style>
